<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-input ttLabel="interbranchmulti_name" [ttModel]="menu.interbranchmulti_name" ttReadonly></tt-input>
        <tt-input ttLabel="stockplace_name_from" [ttModel]="menu.stockplace_name_from" ttReadonly></tt-input>
        <tt-input ttLabel="stockplace_name_to" [ttModel]="menu.stockplace_name_to" ttReadonly></tt-input>
        <tt-input ttLabel="companyname_from" [ttModel]="menu.companyname_from" ttReadonly></tt-input>
        <tt-input ttLabel="companyname_to" [ttModel]="menu.companyname_to" ttReadonly></tt-input>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 p-5" [ttData]="itemsListLevels"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-input class="col-xs-12 sp-0" tt-label="interbranchmulti_name" tt-model="vm.model.menu.interbranchmulti_name" tt-change="vm.model.menu.interbranchmulti_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="stockplace_name_from" tt-model="vm.model.menu.stockplace_name_from" tt-change="vm.model.menu.stockplace_name_from = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="stockplace_name_to" tt-model="vm.model.menu.stockplace_name_to" tt-change="vm.model.menu.stockplace_name_to = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="companyname_from" tt-model="vm.model.menu.companyname_from" tt-change="vm.model.menu.companyname_from = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="companyname_to" tt-model="vm.model.menu.companyname_to" tt-change="vm.model.menu.companyname_to = $value" tt-readonly="true"></tt-input>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 p-5" list-items="vm.model.itemsListLevels" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
